import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class ServiceCategoryTaskService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'ServiceCategoryTask/';
  // fetch all ServiceCategoryTask in the database
  allServiceCategoryTask(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getServiceCategoryTask(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getServiceCategoryTaskByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postServiceCategoryTask(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteServiceCategoryTask(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateServiceCategoryTask(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
